// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__yhv57","ranges":"BmiRanges_ranges__1u-bH"};